// live streaming
export const liveStreaming = "/live_streaming";
// program info
export const programInfo = "/program_info";
// schedule info
export const scheduleInfo = "/schedule_info";
// playlist
export const playlist = "/get_playlist";
// sub info
export const subinfo = "/user_sub_status";
// sing up
export const signup = "/signup";

export const send_opt = "/otp/send";
export const otp_verify = "/otp/verification";